import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { store } from "./Store/Store";
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from "react-redux";
import Toast from './Utility/Toast/Toast';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <Toast />
  </Provider>
);

